import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "white-bg-border" }
const _hoisted_9 = { class: "change-password-section" }
const _hoisted_10 = { class: "change-password-form" }
const _hoisted_11 = { class: "admin-input-field" }
const _hoisted_12 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_13 = { class: "admin-input-field" }
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = { class: "admin-input-field" }
const _hoisted_16 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_17 = { class: "admin-input-field-submit" }
const _hoisted_18 = {
  id: "cPwdSubmitBtn",
  type: "submit",
  class: "admin-btn-outline-primary"
}
const _hoisted_19 = { class: "admin-site-footer" }
const _hoisted_20 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.constants.CHANGE_PASSWORD_TEXT), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("form", {
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
                  id: "changePasswordForm"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.OLD_PASSWORD_LABEL), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "cPwdOldPwdInput",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.current_password) = $event)),
                        type: "password",
                        name: "current_password",
                        placeholder: "Enter old password",
                        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorMsg = ''))
                      }, null, 544), [
                        [_vModelText, _ctx.current_password]
                      ]),
                      (_ctx.errorMsg==='Incorrect current password.'||!_ctx.current_password)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.errorMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.NEW_PASSWORD_LABEL), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "cPwdNewPwdInput",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.new_password) = $event)),
                        type: "password",
                        name: "new_password",
                        placeholder: "Enter new password",
                        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMsg = ''))
                      }, null, 544), [
                        [_vModelText, _ctx.new_password]
                      ]),
                      (_ctx.errorMsg==='New password and confirm password do not match.'||_ctx.errorMsg==='New password cannot be the same as the Old password.'||!_ctx.new_password)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.CONFIRM_PASSWORD_LABEL), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "cPwdCPwdInput",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirm_password) = $event)),
                        type: "password",
                        name: "confirm_password",
                        placeholder: "Enter confirm password"
                      }, null, 512), [
                        [_vModelText, _ctx.confirm_password]
                      ]),
                      (!_ctx.confirm_password)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.errorMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 1),
                      _createElementVNode("button", {
                        id: "cPwdCancelBtn",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
                        class: "admin-btn-outline-secondary"
                      }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                    ])
                  ])
                ], 32)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ])
  ]))
}